import React, { useEffect, useRef, useState } from 'react';
import Message from './Message';
import { useLanguage } from '@/contexts/LanguageContext';
import './MessageList.css';

const MessageList = ({ messages, isLoading, isConnecting, agentState = 'listening', onClickableTextClick, sessionId, userId, token }) => {
  const { t } = useLanguage();
  const messagesEndRef = useRef(null);
  const messageListRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Check if user has scrolled up
  const handleScroll = () => {
    if (messageListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = messageListRef.current;
      const isScrolledUp = scrollHeight - scrollTop - clientHeight > 100;
      setShowScrollButton(isScrolledUp);
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Show typing indicator when:
  // - Agent is thinking or speaking
  // - OR when no messages yet (initial state)
  // - OR when explicitly loading
  const shouldShowTyping = (
    agentState === 'thinking' || 
    agentState === 'speaking' || 
    isLoading || 
    messages.length === 0
  );

  return (
    <div className="message-list-container">
      <div className="message-list" ref={messageListRef} onScroll={handleScroll}>
        {messages.map((msg) => (
          <Message 
            key={msg.id} 
            message={msg} 
            isUser={msg.sender === 'user'}
            onClickableTextClick={onClickableTextClick}
            sessionId={sessionId}
            userId={userId}
            token={token}
          />
        ))}
        {shouldShowTyping && (
          <div className="typing-indicator-wrapper">
            <div className="typing-indicator-header">
              <div className="typing-avatar">
                <img src="/assets/agent-logo.svg" alt="Agent" className="agent-avatar-icon" />
              </div>
              <div className="typing-label">
                <span className="message-label">{t('livechat')}</span>
              </div>
            </div>
            <div className="typing-indicator">
              <div className="typing-dot"></div>
              <div className="typing-dot"></div>
              <div className="typing-dot"></div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
      
      {showScrollButton && (
        <button 
          className="scroll-to-bottom-button" 
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
        >
          <img src="/assets/btn-scroll.svg" alt="Scroll to bottom" />
        </button>
      )}
    </div>
  );
};

export default MessageList;
